import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { cn } from "../../lib/utils";

const MainTabList = ({
  activeTab,
  setActiveTab,
  tabsKey,
  children,
  parentClass = true,
  className = ""
}) => {
  return (
    <Tabs defaultValue={activeTab} value={activeTab} onValueChange={(e) => setActiveTab(e)}>
      <TabsList className="flex lg:w-fit w-full lg:justify-center h-auto justify-start gap-2 overflow-x-auto lg:flex-nowrap hide-scrollbar">
        {tabsKey?.map((item, index) => (
          <TabsTrigger key={index} value={item?.tabValue ? item?.tabValue : item?.value} className="w-fit">
            {item?.name}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value={activeTab}>
        <div className={cn(`${parentClass ? "p-4 border rounded-lg bg-muted dark:bg-background" : ""}`, className)}>
          {children}
        </div>
      </TabsContent>
    </Tabs>
  );
};

export default MainTabList;
